import store from '@/store'

export default {
  bind(el, binding, vnode) {
    const onKeyDown = event => {
      if(event.code === 'Escape' && store.getters['ui/isNavigationOpen']) {
        event.stopPropagation()
        store.dispatch('ui/toggleValue', { key: 'isNavigationOpen' })
        document.querySelector('.navigation-toggler').focus()
      }
    }

    const onFocusOut = event => {
      if(el.contains(event.relatedTarget)) return

      if(store.getters['ui/isNavigationOpen']) {
        store.dispatch('ui/toggleValue', { key: 'isNavigationOpen' })
      }
    }

    el.addEventListener('keydown', onKeyDown)
    el.addEventListener('focusout', onFocusOut)
  },
  unbind(el) {
    el.removeEventListener('keydown')
    el.removeEventListener('focusout')
  }
}
